import { faTrash, faTrashAlt } from "@fortawesome/pro-light-svg-icons";
import { Formik, Field, isEmptyArray } from "formik";
import React, { useState, useEffect, useContext } from "react";
import { Tabs, Tab, Row, Col, Form, Button, Modal } from "react-bootstrap";
import { useDeepEffect, useRouterParams } from "../../../abstracts";
import {
  AddToolTip,
  EmployeeSelectDropdown,
  ErrorsWarnings,
  FieldDropSide,
  FileNameDropSide,
  ManagePayrollTabLayout,
} from "../../../components";
import {
  EMPLOYEE_RECORDS_TO_FETCH,
  formFields,
  getAdvancedPathWithParam,
  managePayrollFormNames,
  MANAGE_PAYROLL_ROUTES,
  ROUTES,
  scrollToErrorControl,
  ssnMasking,
  UploadedFileType,
  usDateFormat,
} from "../../../utils";
import {
  ErrorListingPayroll,
  SliderPanel,
  Link,
  LoaderWrapper,
  CsplTable as Table,
} from "../../../components";
import { camelCase, get, isEmpty, isUndefined, set } from "lodash";
import { withAppLayout } from "../../../hoc";
import {
  acceptAllDataChangeValidationInaFile,
  acceptEmployeeWarnings,
  deleteTempEmployeeById,
  getAllRecords,
  getCountriesList,
  getEmployeeClassificationType,
  getErrorAndWarningMetadata,
  getFileInformationByFileId,
  getPayrollFrequencies,
  getStates,
  getTempEmployeeDetailsforPayroll,
  getWarningsInECR,
  submitAndUpdateECR,
} from "../../../services";
import CensusFormDetails from "./CensusFormDetails";
import { useHistory } from "react-router-dom";
import PayrollFormDetails from "./PayrollFormDetails";
import { getFileInfo, managePayrollStore } from "../../../contexts";
import authService from "../../../components/api-authorization/AuthorizeService";
import permissions from "../../../mocks/menuPermissions.json";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExclamationTriangle,
  faTimes,
} from "@fortawesome/pro-light-svg-icons";

const PayrollCensusDetails = (props) => {
  const {
    //history,
    countTrigger,
    setcountTrigger,
    setSliderOpen,
    employeeId,
    payrollId,
    selectedTabIndex,
    setTabIndex,
    homeSetIsSubmit,
    menu = "payroll",
    subMenu = "uploadFile",
    countries,
    states,
    frequencyList,
  } = props;
  const { state, dispatch } = useContext(managePayrollStore);
  const fileTypeInformation = get(state, "api.data.fileType");
  const [censusTabIndex, setCensusTabIndex] = useState(
    UploadedFileType.IsPayrollOnly === fileTypeInformation
      ? "payroll"
      : "census"
  );
  const [append, setAppend] = useState(false);
  const [toggleEmp, setToggleEmp] = useState(false);
  const [employeeData, setEmployeeData] = useState(null);
  const [acceptedRecordList, setAcceptedRecordList] = useState([]);
  const [existingEmployeeData, setExistingEmployeeData] = useState(null);
  const fields = formFields[managePayrollFormNames.ERROR_CORRECTION_FORM];
  const [stopInfiniteScroll, setStopInfiniteScroll] = useState(false);
  const [filteredValues, setFilteredValues] = useState([]);
  const [payrollWarnings, setPayrollWarnings] = useState([]);
  const [censusWarnings, setCensusWarnings] = useState([]);
  const [payrollErrors, setPayrollErrors] = useState([]);
  const [censusErrors, setCensusErrors] = useState([]);
  const [isSliderOpen, setIsSliderOpen] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [dataChangeValidations, setDataChangeValidations] = useState([]);
  const [employeeInfo, setEmployeeInfo] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading1, setIsLoading1] = useState(false);
  const [isStartDate, setIsStartDate] = useState(false);
  const [isEndDate, setIsEndDate] = useState(false);
  const [census, setCensus] = useState();
  const [classificationList, setClassificationList] = useState();
  const [isSubmit, setIsSubmit] = useState(false);
  const payrollDetails = get(state, "api.data", {});
  const history = useHistory();
  const [errorList, setErrorList] = useState({});
  const [deleteContributionId, setDeleteContributionId] = useState([]);
  const contirbutionIds = [...new Set(deleteContributionId)];
  const [deleteCompensationError, setDeleteCompensationError] = useState([]);
  const compensationIds = [...new Set(deleteCompensationError)];
  const [hoursErrorId, setHoursErrorId] = useState([]);
  const [errorsAndWarningsInfo, setErrorsAndWarningsInfo] = useState([]);
  const [recordToDelete, setRecordToDelete] = useState({});
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(employeeId);
  const [isAllowedUpdate, setIsAllowedUpdate] = useState(false);
  const [isAllowedDelete, setIsAllowedDelete] = useState(false);
  const [request, setRequest] = useState({
    fileId: payrollId,
    from: 0,
    offset: EMPLOYEE_RECORDS_TO_FETCH,
    searchInput: "",
  });
  let errorMappedData = [...payrollErrors, ...censusErrors];
  useEffect(() => {
    if (!isEmptyArray(hoursErrorId) || !isEmpty(hoursErrorId)) {
      acceptEmployeeWarnings({
        acceptedWarningIds: [hoursErrorId],
        fileUploadId: employeeData.fileUploadId,
      });
    }
  }, [hoursErrorId]);
  useEffect(() => {
    if (!isEmptyArray(deleteContributionId))
      acceptEmployeeWarnings({
        acceptedWarningIds: deleteContributionId,
        fileUploadId: employeeData.fileUploadId,
      });
  }, [deleteContributionId]);
  useEffect(() => {
    if (!isEmptyArray(deleteCompensationError))
      acceptEmployeeWarnings({
        acceptedWarningIds: deleteCompensationError,
        fileUploadId: employeeData.fileUploadId,
      });
  }, [deleteCompensationError]);
  useEffect(() => {
    dispatch(getFileInfo(payrollId, dispatch, state, setIsLoading));
  }, [payrollId]);

  let accpectedIds = contirbutionIds.concat(compensationIds, hoursErrorId);
  useDeepEffect(() => {
    accpectedIds = contirbutionIds.concat(compensationIds, hoursErrorId);
  }, [hoursErrorId]);
  const [roleName, setRoleName] = useState("VOU");
  useEffect(() => {
    getRole();
  }, []);
  const getRole = async () => {
    setRoleName(await authService.getRole());
  };
  let fileValue = "",
    systemValue = "";

  const onTabSelect = (id) => {
    setTabIndex(id);
  };
  const onCensusTabSelect = (id) => {
    setCensusTabIndex(id);
  };
  const getValidationErrorsPage = () => {
    history.push({
      pathname: `${MANAGE_PAYROLL_ROUTES.CENSUS_AND_PAYROLL}/${payrollId}?tab=2`,
    });
  };
  const onFormSubmit = (values, { setErrors, setFieldError }) => {
    setIsLoading1(true);
    let updatedValues = { ...values, acceptedErrorIds: accpectedIds };
    let finalValues = {
      payrollEmployeeViewModel: updatedValues,
      existingPayrollEmployeeViewModel: existingEmployeeData,
    };
    //submitAndUpdateECR(updatedValues, data.fileType )
    submitAndUpdateECR(finalValues, payrollDetails.fileType)
      .then((res) => {
        if (res) {
          getTempEmployeeDetailsforPayroll(employeeId).then((response) => {
            if (response.errorMessages.length == 0) {
              setSliderOpen(false);
            }
            setEmployeeData(response);
            setExistingEmployeeData({ ...response });
            if (response.leaveStartDate == null) setIsStartDate(false);
            else setIsStartDate(true);
            if (response.leaveEndDate == null) setIsEndDate(false);
            else setIsEndDate(true);

            let payrollMapData = response.errorMessages.filter(
              (_) => _.errorType == 2 && _.processReferenceId != 2
            );
            setPayrollWarnings(
              payrollMapData.map((data) => {
                return { ...data, checked: false };
              })
            );
            // getEmployeeClassificationType(response.companyId).then((response1) => {
            //   setClassificationList(response1);
            // });
            let censusMapData = response.errorMessages.filter(
              (_) => _.errorType == 2 && _.processReferenceId == 2
            );
            setCensusWarnings(
              censusMapData.map((data) => {
                return { ...data, checked: false };
              })
            );
            var payrollError = response.errorMessages.filter(
              (_) => _.errorType == 1 && _.processReferenceId != 2
            );

            response.contributions?.forEach((_) => {
              _.errorMessages?.forEach((_) => {
                if (_.errorType == 1) payrollError.push(_);
              });
            });
            response.payrollLoans?.forEach((_) => {
              _.errorMessages?.forEach((_) => {
                if (_.errorType == 1) payrollError.push(_);
              });
            });

            var dataValidationErrorCount = response.errorMessages?.filter(
              (_) => _.errorType === 3
            );
            dataValidationErrorCount.forEach((_) => {
              _["dataToSave"] = true;
            });
            if (dataValidationErrorCount.length > 0) {
              setIsSliderOpen(true);
            }
            var notification = response.errorMessages.filter(
              (x) => x.errorType === 4
            );
            setEmployeeInfo({
              employeeName: response.firstName + response.lastName,
              uniqueId: response.uniquePersonalIdentification,
            });

            var payrollWarning = response.errorMessages.filter(
              (_) => _.errorType == 2 && _.processReferenceId != 2
            );

            response.contributions?.forEach((_) => {
              _.errorMessages?.forEach((_) => {
                if (_.errorType == 2) payrollWarning.push(_);
              });
            });
            response.payrollLoans?.forEach((_) => {
              _.errorMessages?.forEach((_) => {
                if (_.errorType == 2) payrollWarning.push(_);
              });
            });
            if (notification.length > 0) setModalOpen(true);
            setPayrollErrors(payrollError);
            setNotifications(notification);
            setDataChangeValidations(dataValidationErrorCount);
            setPayrollWarnings(
              payrollWarning.map((data) => {
                return { ...data, checked: false };
              })
            );
            setCensusErrors(
              response.errorMessages.filter(
                (_) => _.errorType == 1 && _.processReferenceId == 2
              )
            );
            var tempError = {};

            get(response, "errorMessages", []).forEach((_) => {
              if (_.errorType == 1 || _.errorType == 2) {
                switch (_.controlName) {
                  case "ytdHours":
                    tempError["hoursDetails"] = [
                      {
                        ytdHours: _.messageDescCode,
                      },
                    ];
                    break;

                  case "payPeriodHours":
                    tempError["hoursDetails"] = [
                      {
                        payPeriodHours: _.messageDescCode,
                      },
                    ];
                    break;
                  case "payPeriodGrossCompensation":
                    set(
                      tempError,
                      "compensations[0].payPeriodAmount",
                      _.messageDescCode
                    );
                    break;
                  case "payPeriodPlanCompensation":
                    set(
                      tempError,
                      "compensations[1].payPeriodAmount",
                      _.messageDescCode
                    );
                    break;
                  case "ytdGrossCompensation":
                    tempError["compensations"] = [
                      {
                        ytdAmount: _.messageDescCode,
                      },
                      ...get(tempError, "compensations", []),
                    ];
                    break;
                  case "ytdPlanCompensation":
                    tempError["compensations"] = [
                      ...get(tempError, "compensations", []),
                      {
                        ytdAmount: _.messageDescCode,
                      },
                    ];
                    break;
                  default:
                    set(tempError, _.controlName, _.messageDescCode);
                    break;
                }
              }
            });
            const contributions = get(response, "contributions", []);
            if (contributions != null && contributions.length > 0) {
              contributions?.forEach((_, i) => {
                _?.errorMessages?.forEach((x, ind) => {
                  set(
                    tempError,
                    `${"contributions"}[${i}].${"contributionAmount"}`,
                    x.messageDescCode
                  );
                });
              });
            }
            const payrollLoansData = get(response, "payrollLoans", []);
            if (payrollLoansData != null && payrollLoansData.length > 0) {
              payrollLoansData?.forEach((_, i) => {
                _?.errorMessages?.forEach((x, ind) => {
                  set(
                    tempError,
                    x.controlName == "loanNumber"
                      ? `${fields.payrollLoans}[${i}].${x.controlName}`
                      : `${fields.payrollLoans}[${i}].repaymentAmount`,
                    x.messageDescCode
                  );
                });
              });
            }
            setErrors(tempError);
            setErrorList(tempError);
            setCensus(true);
            setIsLoading1(false);

            if (warnings.count + errorMappedData.count == 0) {
              let findIndex =
                filteredValues.findIndex((_) => _.id === selectedEmployee) + 1;
              let [selectedEmpId] = filteredValues.filter((_, index) => {
                return index === findIndex;
              });
              if (selectedEmpId === undefined) {
                setSliderOpen(false);
              } else {
                setSelectedEmployee(selectedEmpId.id);
              }
              homeSetIsSubmit(true);
            }
            setcountTrigger(!countTrigger);
          });
        }
        dispatch(getFileInfo(payrollId, dispatch, state, setIsLoading));
        setIsLoading1(false);
      })
      .catch((error) => {
        setIsLoading1(false);
      });
  };
  const fileStatus = get(state, "api.data.fileStatus", {});
  const pendingSubmission =
    fileStatus === "AwaitingFunding" ||
    fileStatus === "AwaitingFundConfirmation" ||
    fileStatus === "AwaitingTrade"
      ? true
      : false;

  const Func = (value, index) => {
    var data = [];
    dataChangeValidations.map((row, i) => {
      if (i == index) {
        data.push({ ...row, dataToSave: value });
      } else data.push(row);
    });
    setDataChangeValidations(data);
  };
  const onSubmitSave = (values, { setErrors, setFieldError }) => {
    setIsLoading1(true);

    var d = dataChangeValidations.every((x) => x.dataToSave);
    if (d) {
      setIsLoading1(true);
      acceptAllDataChangeValidationInaFile({
        employeeId: employeeId,
        fileUploadId: employeeData.fileUploadId,
      }).then((response) => {
        // if (response) {
        //   setIsSliderOpen(false);
        // }
        setIsLoading1(false);
      });
    } else {
      dataChangeValidations.map((x) => {
        if (!x.dataToSave) {
          if (x.controlName == "Classification") {
            //if (fileValue !== "") {

            var d = JSON.parse(x.dynamicValue2);
            var j = JSON.parse(x.dynamicValue1);

            for (const i in d) {
              if (d[i] === "-") d[i] = null;
              employeeData[camelCase(i)] = d[i];
            }
            // fileValue = "";
            //}

            var index = employeeData.employeeClassifications.findIndex(
              (el) => el.classificationTypeId === j.ClassificationTypeId
            );

            var c = classificationList
              ?.flatMap((_) => _.classifications)
              ?.filter((x) => x.code == d.Code)
              ?.map((_) => _.id);
            employeeData.employeeClassifications[index].classificationId = c
              ? c[0]
              : 0;

            employeeData.employeeClassifications[index].code = d.Code;
            employeeData.employeeClassifications[index].effectiveStartDate =
              d.EffectiveStartDate;
            employeeData.employeeClassifications[index].effectiveEndDate =
              d.EffectiveEndDate;
          } else if (
            x.controlName == "AddressDataChange" ||
            x.controlName == "EmployementStatus"
          ) {
            var d = JSON.parse(x.dynamicValue2);
            var j = JSON.parse(x.dynamicValue1);

            for (const i in d) {
              if (d[i] === "-") d[i] = null;
              employeeData[camelCase(i)] = d[i];
            }
            if (
              x.controlName == "AddressDataChange" &&
              employeeData.country == "USA"
            ) {
              employeeData.countryId = 1;
              employeeData.foreignCountry = null;
              employeeData.foreignState = null;
            } else if (x.controlName == "AddressDataChange") {
              employeeData.countryId = 2;
              employeeData.foreignCountry = employeeData.country;
              employeeData.foreignState = employeeData.state;
              employeeData.country = "Other";
              employeeData.state = null;
              employeeData.stateId = null;
            }
          } else {
            if (x.controlName == "HCEIndicator") {
              if (x.dynamicValue2 === "") {
                employeeData[camelCase(x.controlName)] = null;
              } else if (x.dynamicValue2 == "Y" || x.dynamicValue2 == "y") {
                employeeData[camelCase(x.controlName)] = true;
              } else if (x.dynamicValue2 == "N" || x.dynamicValue2 == "n") {
                employeeData[camelCase(x.controlName)] = false;
              }
            } else if (x.controlName == "PrimaryPhoneNumber") {
              employeeData.mobilePhoneNumber = x.dynamicValue2;
            } else {
              employeeData[camelCase(x.controlName)] = x.dynamicValue2;
            }
          }
        }
      });
      setEmployeeData(employeeData);

      let finalValues = {
        payrollEmployeeViewModel: employeeData,
        existingPayrollEmployeeViewModel: existingEmployeeData,
      };
      setIsLoading(true);

      submitAndUpdateECR(finalValues, payrollDetails.fileType)
        .then((resp) => {
          if (resp) {
            getTempEmployeeDetailsforPayroll(employeeId).then((response) => {
              // if (get(resp, "errorMessages", []).length === 0) {
              //   setIsSubmit(!isSubmit);
              //   // setErrorPage(false);
              // } else {
              //   // setErrorPage(false);
              // }
              if (response.errorMessages.length == 0) {
                setSliderOpen(false);
              }
              setEmployeeData(response);
              setExistingEmployeeData({ ...response });
              if (response.leaveStartDate == null) setIsStartDate(false);
              else setIsStartDate(true);
              if (response.leaveEndDate == null) setIsEndDate(false);
              else setIsEndDate(true);

              let payrollMapData = response.errorMessages.filter(
                (_) => _.errorType == 2 && _.processReferenceId != 2
              );
              setPayrollWarnings(
                payrollMapData.map((data) => {
                  return { ...data, checked: false };
                })
              );
              // getEmployeeClassificationType(response.companyId).then((response1) => {
              //   setClassificationList(response1);
              // });
              let censusMapData = response.errorMessages.filter(
                (_) => _.errorType == 2 && _.processReferenceId == 2
              );
              setCensusWarnings(
                censusMapData.map((data) => {
                  return { ...data, checked: false };
                })
              );
              var payrollError = response.errorMessages.filter(
                (_) => _.errorType == 1 && _.processReferenceId != 2
              );

              response.contributions?.forEach((_) => {
                _.errorMessages?.forEach((_) => {
                  if (_.errorType == 1) payrollError.push(_);
                });
              });
              response.payrollLoans?.forEach((_) => {
                _.errorMessages?.forEach((_) => {
                  if (_.errorType == 1) payrollError.push(_);
                });
              });

              var dataValidationErrorCount = response.errorMessages?.filter(
                (_) => _.errorType === 3
              );
              dataValidationErrorCount.forEach((_) => {
                _["dataToSave"] = true;
              });
              if (dataValidationErrorCount.length > 0) {
                setIsSliderOpen(true);
              }
              var notification = response.errorMessages.filter(
                (x) => x.errorType === 4
              );
              setEmployeeInfo({
                employeeName: response.firstName + response.lastName,
                uniqueId: response.uniquePersonalIdentification,
              });

              var payrollWarning = response.errorMessages.filter(
                (_) => _.errorType == 2 && _.processReferenceId != 2
              );

              response.contributions?.forEach((_) => {
                _.errorMessages?.forEach((_) => {
                  if (_.errorType == 2) payrollWarning.push(_);
                });
              });
              response.payrollLoans?.forEach((_) => {
                _.errorMessages?.forEach((_) => {
                  if (_.errorType == 2) payrollWarning.push(_);
                });
              });
              if (notification.length > 0) setModalOpen(true);
              setPayrollErrors(payrollError);
              setNotifications(notification);
              setDataChangeValidations(dataValidationErrorCount);
              setPayrollWarnings(
                payrollWarning.map((data) => {
                  return { ...data, checked: false };
                })
              );
              setCensusErrors(
                response.errorMessages.filter(
                  (_) => _.errorType == 1 && _.processReferenceId == 2
                )
              );
              var tempError = {};

              get(response, "errorMessages", []).forEach((_) => {
                if (_.errorType == 1 || _.errorType == 2) {
                  switch (_.controlName) {
                    case "ytdHours":
                      tempError["hoursDetails"] = [
                        {
                          ytdHours: _.messageDescCode,
                        },
                      ];
                      break;

                    case "payPeriodHours":
                      tempError["hoursDetails"] = [
                        {
                          payPeriodHours: _.messageDescCode,
                        },
                      ];
                      break;
                    case "payPeriodGrossCompensation":
                      set(
                        tempError,
                        "compensations[0].payPeriodAmount",
                        _.messageDescCode
                      );
                      break;
                    case "payPeriodPlanCompensation":
                      set(
                        tempError,
                        "compensations[1].payPeriodAmount",
                        _.messageDescCode
                      );
                      break;
                    case "ytdGrossCompensation":
                      tempError["compensations"] = [
                        {
                          ytdAmount: _.messageDescCode,
                        },
                        ...get(tempError, "compensations", []),
                      ];
                      break;
                    case "ytdPlanCompensation":
                      tempError["compensations"] = [
                        ...get(tempError, "compensations", []),
                        {
                          ytdAmount: _.messageDescCode,
                        },
                      ];
                      break;
                    default:
                      set(tempError, _.controlName, _.messageDescCode);
                      break;
                  }
                }
              });
              const contributions = get(response, "contributions", []);
              if (contributions != null && contributions.length > 0) {
                contributions?.forEach((_, i) => {
                  _?.errorMessages?.forEach((x, ind) => {
                    set(
                      tempError,
                      `${"contributions"}[${i}].${"contributionAmount"}`,
                      x.messageDescCode
                    );
                  });
                });
              }
              const payrollLoansData = get(response, "payrollLoans", []);
              if (payrollLoansData != null && payrollLoansData.length > 0) {
                payrollLoansData?.forEach((_, i) => {
                  _?.errorMessages?.forEach((x, ind) => {
                    set(
                      tempError,
                      x.controlName == "loanNumber"
                        ? `${fields.payrollLoans}[${i}].${x.controlName}`
                        : `${fields.payrollLoans}[${i}].repaymentAmount`,
                      x.messageDescCode
                    );
                  });
                });
              }
              setErrors(tempError);
              setErrorList(tempError);
              setCensus(true);
              setIsLoading1(false);

              if (warnings.count + errorMappedData.count == 0) {
                let findIndex =
                  filteredValues.findIndex((_) => _.id === selectedEmployee) +
                  1;
                let [selectedEmpId] = filteredValues.filter((_, index) => {
                  return index === findIndex;
                });
                if (selectedEmpId === undefined) {
                  setcountTrigger(!countTrigger);
                  setSliderOpen(false);
                } else {
                  setSelectedEmployee(selectedEmpId.id);
                }
                homeSetIsSubmit(true);
              }
            });
            setIsLoading(false);
          } else {
            //  window.location.reload();
          }
          setIsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
        });
    }
    setDataChangeValidations([]);
    //onFormSubmit(values, { setErrors, setFieldError });
  };
  const dataValidationTableHeader = [
    {
      label: "Field Name",
      className: "column-fieldName",
      columnName: "fieldName",
      style: {
        width: "16.66%",
      },
    },
    {
      label: "Error Details",
      className: "column-errorDetails",
      columnName: "errorDetails",
      style: {
        width: "16.66%",
      },
    },
    {
      label: "Data in File",
      className: "column-dataInFile",
      columnName: "dataInFile",
      style: {
        width: "16.66%",
      },
    },
    {
      label: "Data in System",
      className: "column-dataInSystem",
      columnName: "dataInSystem",
      style: {
        width: "16.66%",
      },
    },
    {
      label: "Notifications",
      className: "column-notifications",
      columnName: "notifications",
      style: {
        width: "16.66%",
      },
    },
    {
      label: "Data to Save",
      className: "column-dataToSave",
      columnName: "dataToSave",
      style: {
        width: "16.66%",
      },
    },
  ];

  const onPayrollDeleteClick = () => {
    setIsDeleteModalOpen(true);
  };
  const onDeleteHandleClose = () => {
    setIsDeleteModalOpen(false);
  };

  const onDeleteConfirmClick = () => {
    const id = get(recordToDelete, "id");
    setIsLoading1(true);
    deleteTempEmployeeById(employeeData.id).then((response) => {
      let findIndex =
        filteredValues.findIndex((_) => _.id === selectedEmployee) + 1;
      let [selectedEmpId] = filteredValues.filter((_, index) => {
        return index === findIndex;
      });
      if (selectedEmpId === undefined) {
        setcountTrigger(!countTrigger);
        setSliderOpen(false);
      } else {
        setSelectedEmployee(selectedEmpId.id);
      }

      setIsLoading1(false);

      // history.push(
      //   getAdvancedPathWithParam({
      //     path: `${ROUTES.PAYROLL_FILE_STATUS}/${payrollId}?tab=2`,
      //   })
      // );
      // if (keyValue === "all_records") {
      // if (filteredValues.length === 1)
      //   history.push({
      //     pathname: MANAGE_PAYROLL_ROUTES.UPLOADED_FILES_LISTING,
      //   });
      // else {
      //   let findIndex =
      //     filteredValues.findIndex((_) => _.id === id) - 1;
      //   findIndex = findIndex < 0 ? 1 : findIndex;
      //   // setEmployeeId(get(filteredValues, `${findIndex}.id`, 0));
      // }
      // else {
      //   if (filteredValues.length === 1)
      //     history.push({
      //       pathname: MANAGE_PAYROLL_ROUTES.UPLOADED_FILES_LISTING,
      //     });
      //   else {
      //     let findIndex = filteredValues.findIndex((_) => _.id === id) - 1;
      //     findIndex = findIndex < 0 ? 1 : findIndex;
      //     setEmployeeId(get(filteredValues, `${findIndex}.id`, 0));
      //   }
      // }
      // refresh();
      var idLength = payrollDetails.totalRecords;
      if (idLength == 1) {
        setIsDeleteModalOpen(false);
        history.push({
          pathname: MANAGE_PAYROLL_ROUTES.UPLOADED_FILES_LISTING,
        });
      } else {
        setIsDeleteModalOpen(false);
        setSliderOpen(false);
        // setRecordToDelete({});
      }
    });
  };

  const AcceptNotificationClick = () => {
    setModalOpen(false);
    acceptEmployeeWarnings({
      acceptedWarningIds: notifications.map((x) => x.id),
      fileUploadId: employeeData.fileUploadId,
    });
  };

  useDeepEffect(() => {
    if (permissions) {
      setIsAllowedUpdate(
        permissions[roleName][menu + "SubMenu"][camelCase(subMenu)].includes(
          "U"
        )
      );
      setIsAllowedDelete(
        permissions[roleName][menu + "SubMenu"][camelCase(subMenu)].includes(
          "D"
        )
      );
    }
  }, [roleName]);

  useEffect(() => {
    setCensus(false);
    setIsLoading1(true);
    getTempEmployeeDetailsforPayroll(selectedEmployee).then((response) => {
      if (response) {
        setEmployeeData(response);
        setExistingEmployeeData({ ...response });
        if (response.leaveStartDate == null) setIsStartDate(false);
        else setIsStartDate(true);
        if (response.leaveEndDate == null) setIsEndDate(false);
        else setIsEndDate(true);

        let payrollMapData = response.errorMessages.filter(
          (_) => _.errorType == 2 && _.processReferenceId != 2
        );
        setPayrollWarnings(
          payrollMapData.map((data) => {
            return { ...data, checked: false };
          })
        );
        getEmployeeClassificationType(response.companyId).then((response1) => {
          setClassificationList(response1);
        });
        let censusMapData = response.errorMessages.filter(
          (_) => _.errorType == 2 && _.processReferenceId == 2
        );
        setCensusWarnings(
          censusMapData.map((data) => {
            return { ...data, checked: false };
          })
        );
        var payrollError = response.errorMessages.filter(
          (_) => _.errorType == 1 && _.processReferenceId != 2
        );

        response.contributions?.forEach((_) => {
          _.errorMessages?.forEach((_) => {
            if (_.errorType == 1) payrollError.push(_);
          });
        });
        response.payrollLoans?.forEach((_) => {
          _.errorMessages?.forEach((_) => {
            if (_.errorType == 1) payrollError.push(_);
          });
        });

        var dataValidationErrorCount = response.errorMessages?.filter(
          (_) => _.errorType === 3
        );
        dataValidationErrorCount.forEach((_) => {
          _["dataToSave"] = true;
        });
        if (dataValidationErrorCount.length > 0) {
          setIsSliderOpen(true);
        }
        var notification = response.errorMessages.filter(
          (x) => x.errorType === 4
        );
        setEmployeeInfo({
          employeeName: response.firstName + response.lastName,
          uniqueId: response.uniquePersonalIdentification,
        });

        var payrollWarning = response.errorMessages.filter(
          (_) => _.errorType == 2 && _.processReferenceId != 2
        );

        response.contributions?.forEach((_) => {
          _.errorMessages?.forEach((_) => {
            if (_.errorType == 2) payrollWarning.push(_);
          });
        });
        response.payrollLoans?.forEach((_) => {
          _.errorMessages?.forEach((_) => {
            if (_.errorType == 2) payrollWarning.push(_);
          });
        });
        if (notification.length > 0) setModalOpen(true);
        setPayrollErrors(payrollError);
        setNotifications(notification);
        setDataChangeValidations(dataValidationErrorCount);
        setPayrollWarnings(
          payrollWarning.map((data) => {
            return { ...data, checked: false };
          })
        );
        setCensusErrors(
          response.errorMessages.filter(
            (_) => _.errorType == 1 && _.processReferenceId == 2
          )
        );
        setCensus(true);
        setIsLoading1(false);
        var tempError = {};
        get(response, "errorMessages", []).forEach((_) => {
          if (_.errorType == 1 || _.errorType == 2)
            switch (_.controlName) {
              case "ytdHours":
                tempError["hoursDetails"] = [
                  {
                    ytdHours: _.messageDescCode,
                  },
                ];
                break;

              case "payPeriodHours":
                tempError["hoursDetails"] = [
                  {
                    payPeriodHours: _.messageDescCode,
                  },
                ];
                break;
              case "payPeriodGrossCompensation":
                set(
                  tempError,
                  "compensations[0].payPeriodAmount",
                  _.messageDescCode
                );
                break;
              case "payPeriodPlanCompensation":
                set(
                  tempError,
                  "compensations[1].payPeriodAmount",
                  _.messageDescCode
                );
                break;
              case "ytdGrossCompensation":
                tempError["compensations"] = [
                  {
                    ytdAmount: _.messageDescCode,
                  },
                  ...get(tempError, "compensations", []),
                ];
                break;
              case "ytdPlanCompensation":
                tempError["compensations"] = [
                  ...get(tempError, "compensations", []),
                  {
                    ytdAmount: _.messageDescCode,
                  },
                ];
                break;
              default:
                tempError[_.controlName] = _.messageDescCode;
                break;
            }
        });
        const contributions = get(response, "contributions", []);
        if (contributions != null && contributions.length > 0) {
          contributions?.forEach((_, i) => {
            _?.errorMessages?.forEach((x, ind) => {
              set(
                tempError,
                `${"contributions"}[${i}].${"contributionAmount"}`,
                x.messageDescCode
              );
            });
          });
        }
        const payrollLoansData = get(response, "payrollLoans", []);
        if (payrollLoansData != null && payrollLoansData.length > 0) {
          payrollLoansData?.forEach((_, i) => {
            _?.errorMessages?.forEach((x, ind) => {
              set(
                tempError,
                x.controlName == "loanNumber"
                  ? `${fields.payrollLoans}[${i}].${x.controlName}`
                  : `${fields.payrollLoans}[${i}].repaymentAmount`,
                x.messageDescCode
              );
            });
          });
        }
        setErrorList(tempError);
      }
    });
  }, [
    selectedEmployee,
    toggleEmp,
    deleteCompensationError,
    deleteContributionId,
    hoursErrorId,
  ]);

  useDeepEffect(() => {
    setIsLoading(true);
    getAllRecords(request)
      .then((response) => {
        if (response.errorReportDetails?.length < EMPLOYEE_RECORDS_TO_FETCH)
          setStopInfiniteScroll(true);
        if (append)
          setFilteredValues([
            ...filteredValues,
            ...response.errorReportDetails,
          ]);
        else {
          setFilteredValues(response.errorReportDetails);
          setStopInfiniteScroll(false);
        }
        var employee = response.errorReportDetails.find(
          (_) => _.id == employeeId
        );
        setRecordToDelete(employee);
        setIsLoading(false);
      })

      .catch((error) => {});
  }, [request]);

  const buttons = [
    {
      label: "Delete Record",
      variant: "link",
      type: "button",
    },
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      onClick: getValidationErrorsPage,
    },
    {
      label: "Next",
      variant: "primary",
      type: "button",
    },
  ];
  const returnArrowClick = () => {
    setcountTrigger(!countTrigger);
    setSliderOpen(false);
    homeSetIsSubmit(true);
  };
  const warnings = [...payrollWarnings, ...censusWarnings];
  // censusTabIndex == "payroll" ? payrollWarnings : censusWarnings;
  const acceptAllWarnings = () => {
    setIsLoading(true);
    acceptEmployeeWarnings({
      acceptedWarningIds: warnings.map((_) => {
        return _.id;
      }),
      fileUploadId: employeeData.fileUploadId,
    })
      .then((response) => {
        if (response) {
          setToggleEmp(!toggleEmp);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };
  const acceptWarnings = (warningId) => {
    setIsLoading(true);
    acceptEmployeeWarnings({
      acceptedWarningIds: [warningId],
      fileUploadId: employeeData.fileUploadId,
    })
      .then((response) => {
        if (response) {
          setToggleEmp(!toggleEmp);
        }
        setIsLoading(false);
        //setAcceptedRecordList([...acceptedRecordList, ...filterId]);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };
  const errorItemClick = (item, tab) => {
    window.setTimeout(() => {
      switch (item.controlName) {
        case "employeeClassifications":
          setCensusTabIndex("census");
          scrollToErrorControl("employeeClassifications[0].code");
          break;
        case "ytdHours":
          //setCensusTabIndex("payroll");
          setCensusTabIndex(
            UploadedFileType.IsDemographyOnly === fileTypeInformation
              ? "census"
              : "payroll"
          );
          scrollToErrorControl("hoursDetails[0].ytdHours");
          break;
        case "payPeriodHours":
          //setCensusTabIndex("payroll");
          setCensusTabIndex(
            UploadedFileType.IsDemographyOnly === fileTypeInformation
              ? "census"
              : "payroll"
          );
          scrollToErrorControl("hoursDetails[0].payPeriodHours");
          break;
        case "payPeriodGrossCompensation":
          setCensusTabIndex("payroll");
          scrollToErrorControl("compensations[0].payPeriodAmount");
          break;
        case "payPeriodPlanCompensation":
          setCensusTabIndex("payroll");
          scrollToErrorControl("compensations[1].payPeriodAmount");
          break;
        case "ytdGrossCompensation":
          setCensusTabIndex("payroll");
          scrollToErrorControl("compensations[0].ytdAmount");
          break;
        case "ytdPlanCompensation":
          setCensusTabIndex("payroll");
          scrollToErrorControl("compensations[1].ytdAmount");
          break;
        case "contributionsDetails":
          setCensusTabIndex("payroll");
          scrollToErrorControl("contributions[0].contributionAmount");
          break;
        case "ytdContributionAmount":
          setCensusTabIndex("payroll");
          scrollToErrorControl("contributions[0].ytdContributionAmount");
          break;
        case "loanNumber":
          setCensusTabIndex("payroll");
          scrollToErrorControl("payrollLoans[0].loanNumber");
          break;
        case "loanDetails":
          setCensusTabIndex("payroll");
          scrollToErrorControl("payrollLoans[0].repaymentAmount");
          break;
        default:
          setCensusTabIndex("census");
          scrollToErrorControl(item.controlName);
          break;
      }
    }, 500);
  };
  // censusTabIndex == "payroll" ? payrollErrors : censusErrors;
  return (
    <div className="w-100 p-4">
      {isDeleteModalOpen && (
        <div className="d-flex delete-record-pop-up">
          <div className="d-flex w-50">
            <div
              className="align-self-center"
              style={{
                padding: "0px 50px",
              }}
            >
              <FontAwesomeIcon
                icon={faExclamationTriangle}
                color="#c4061a"
                size="2x"
              />
            </div>
            <div className="remove-text" style={{ width: "80%" }}>
              <h4>Delete Employee?</h4>

              <div>
                {/* <div>{ssnMasking(get(recordToDelete, "ssn", ""))}</div> */}
                {/* <div>{get(recordToDelete, "employeeName", "")}</div> */}
                <div
                  className="dark-text"
                  style={{ fontSize: "14px", marginBottom: "1%" }}
                >
                  {" "}
                  {employeeInfo.employeeName}
                </div>

                <div className="d-flex justify-content-start">
                  <div className="dark-text align-self-center">
                    {" "}
                    {ssnMasking(employeeInfo.uniqueId)}
                  </div>
                  &nbsp; | &nbsp;
                  <div
                    className="align-self-center"
                    style={{
                      width: "9px",
                      borderRadius: "4.5px",
                      height: "9px",
                      backgroundColor: "#A05A06",
                    }}
                  ></div>
                  &nbsp;&nbsp;
                  <div className="align-self-center">
                    <span className="pending-text ft-14 mr-2">
                      {warnings.length}
                    </span>{" "}
                    Warnings
                  </div>
                  &nbsp;&nbsp;&nbsp;
                  <div
                    className="align-self-center"
                    style={{
                      width: "9px",
                      borderRadius: "4.5px",
                      height: "9px",
                      backgroundColor: "#C4061A",
                    }}
                  ></div>
                  &nbsp;&nbsp;
                  <div className="align-self-center">
                    <span className="error-text ft-14 mr-2">
                      {errorMappedData.length}
                    </span>{" "}
                    Errors
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="d-flex p-4">
            <div className="align-self-center">
              <Button
                type="button"
                variant="secondary"
                onClick={onDeleteConfirmClick}
                className="delete-button-popup mr-3"
              >
                Delete
              </Button>
            </div>
            <div className="align-self-center">
              <Button
                type="button"
                variant="secondary"
                onClick={onDeleteHandleClose}
                className="cancel-button"
              >
                Cancel
              </Button>
            </div>
          </div>
        </div>
      )}

      <LoaderWrapper isLoading={isLoading || isLoading1}>
        <div className="d-flex flex-col payroll-census-tabs">
          <div>
            <h6 className="empl-name-sty">Employee</h6>
            {!isDeleteModalOpen && (
              <div className="d-flex justify-content-between">
                <div style={{ width: "30%" }}>
                  <EmployeeSelectDropdown
                    title={
                      [undefined, null].includes(selectedEmployee) ? (
                        "Employee Name \n SSN"
                      ) : (
                        <AddToolTip
                          placement={"bottom"}
                          name={
                            employeeData
                              ? employeeData?.firstName +
                                " " +
                                employeeData?.middleName +
                                " " +
                                employeeData?.lastName
                              : ""
                          }
                        >
                          {employeeData
                            ? employeeData?.firstName +
                              " " +
                              employeeData?.middleName +
                              " " +
                              employeeData?.lastName
                            : ""}
                          <br></br>
                          {employeeData
                            ? ssnMasking(
                                employeeData?.uniquePersonalIdentification
                              )
                            : ""}
                        </AddToolTip>
                      )
                    }
                    optionsList={filteredValues.map((item, index) => {
                      return {
                        label: item?.employeeName,
                        value: item?.id,
                        ssn: item?.ssn,
                        errorCount: item?.errorCount,
                        warningCount: item?.warningCount,
                      };
                    })}
                    onClick={(event) => {
                      setSelectedEmployee(event.target.value);
                      // getTempEmployeeDetailsforPayroll(
                      //   filteredValues[event.target.value].id
                      // );
                    }}
                    value={filteredValues.map((item, index) => {
                      return {
                        label: item?.ssn,
                        value: index,
                      };
                    })}
                    request={request}
                    setRequest={setRequest}
                    setAppend={setAppend}
                    append={append}
                    isLoading={isLoading}
                  />
                </div>
                <div className="p-2">
                  <Button
                    type="button"
                    variant="secondary"
                    onClick={() => {
                      returnArrowClick();
                    }}
                  >
                    Close
                  </Button>
                </div>
              </div>
            )}
          </div>
          <div
            className="d-flex flex-row"
            style={{
              marginTop: "1%",
              padding: "1%",
              border: "1px solid #bdbdbd",
              borderRadius: "8px",
            }}
          >
            <div style={{ width: "30%", height: "80vh", overflow: "scroll" }}>
              <Tabs
                defaultActiveKey="warning"
                transition={false}
                className="top-level-tab-var w-100 mt-3 mb-4"
                onSelect={onTabSelect}
                activeKey={selectedTabIndex}
                // mountOnEnter
                // unmountOnExit
              >
                <Tab
                  eventKey="warning"
                  title={
                    <div className="d-flex onselect-highlight-error">
                      <div className="mt-1">Warnings</div>{" "}
                      <div
                        className="circle-error-count"
                        style={{
                          background: "#919191",
                        }}
                      >
                        {warnings.length}
                      </div>{" "}
                    </div>
                  }
                >
                  <div
                    style={{
                      overflowY: "scroll",
                      padding: "2px",
                    }}
                  >
                    {isAllowedUpdate && warnings.length !== 0 ? (
                      <div className="d-flex justify-content-between">
                        <div></div>
                        <span
                          className="cursor-pointer fw-600 fs-12 primary-small"
                          onClick={() => {
                            acceptAllWarnings();
                          }}
                        >
                          Accept All
                        </span>
                      </div>
                    ) : null}
                    {warnings.map((data) => {
                      return (
                        <div
                          className="d-flex flex-row justify-content-around error-types-box-var p-0"
                          style={{ margin: "3%" }}
                          onClick={() => {
                            errorItemClick(data);
                          }}
                        >
                          <p className="d-flex flex-col w-75 pl-2 pt-3">
                            <span className="ft-12">
                              Warning Code:{" "}
                              {data.messageCode.substring(
                                0,
                                data.messageCode.indexOf("-")
                              )}
                            </span>
                            <span className="ft-14 fw-500 ">
                              {data.messageCode.substring(
                                data.messageCode.indexOf("-") + 1
                                // data.messageCode.lastIndexOf(".")
                              )}
                            </span>
                          </p>
                          {isAllowedUpdate && (
                            <div
                              onClick={() => acceptWarnings(data.id)}
                              // md="3"
                              className="align-self-center  cursor-pointer primary-small"
                              style={{ color: "$primary", margin: "3%" }}
                            >
                              <u>Accept</u>
                            </div>
                          )}
                        </div>
                      );
                    })}
                    {acceptedRecordList &&
                      acceptedRecordList.map((data, index) => {
                        return (
                          <div
                            className="d-flex flex-row justify-content-around accepted-warning-box-var p-0"
                            style={{ margin: "3%" }}
                          >
                            <p className="d-flex flex-col pl-2 pt-3">
                              <span className="ft-12">
                                Warning Code:{" "}
                                {data.messageCode.substring(
                                  0,
                                  data.messageCode.indexOf("-")
                                )}
                              </span>
                              <span className="ft-14 fw-500">
                                {data.messageCode.substring(
                                  data.messageCode.indexOf("-") + 1
                                  // data.messageCode.lastIndexOf(".")
                                )}
                              </span>
                            </p>
                            <div
                              className="align-self-center black-text cursor-pointer"
                              style={{ color: "#06741A", margin: "3%" }}
                            >
                              Accepted
                            </div>
                          </div>
                        );
                      })}
                  </div>
                </Tab>
                <Tab
                  eventKey="error"
                  title={
                    <div className="d-flex onselect-highlight-error">
                      <div className="mt-1">Errors</div>{" "}
                      <div
                        className="circle-error-count"
                        style={{
                          background: "#919191",
                        }}
                      >
                        {errorMappedData.length}
                      </div>{" "}
                    </div>
                  }
                >
                  <div
                    style={{
                      overflowY: "scroll",
                      padding: "2px",
                    }}
                  >
                    {errorMappedData.map((data) => {
                      return (
                        <div
                          className="p-2 d-flex mb-3 error-types-box-var"
                          // style={{
                          //   border: "1px solid #B7B7B7",
                          //   borderRadius: "5px",
                          // }}
                          onClick={() => {
                            errorItemClick(data);
                          }}
                        >
                          <p className="d-flex flex-col pl-2 pt-3">
                            <span className="ft-12">
                              Error Code: {data.messageCode.substring(0, 5)}
                            </span>
                            <span className="ft-14 fw-500">
                              {data.messageCode.substring(
                                data.messageCode.indexOf("-") + 1
                                // data.messageCode.lastIndexOf(".")
                              )}
                            </span>
                          </p>
                        </div>
                      );
                    })}
                  </div>
                </Tab>
              </Tabs>
            </div>

            <div
              className="pl-3 ml-2"
              style={{
                width: "70%",
                height: "80vh",
                borderLeft: "2px solid #b7b7b7",
              }}
            >
              <Formik
                onSubmit={onFormSubmit}
                initialValues={{
                  ...employeeData,
                  // country: "USA",
                  compensationDetailsRecordType: 0,
                  contributionDetailsRecordType: 0,
                  errorReportRecordType: 0,
                  payrollLoansRecordType: 0,
                }}
                initialErrors={errorList}
                enableReinitialize
                validateOnChange={false}
                validateOnBlur={false}
                validateOnMount={false}
              >
                {({
                  setFieldTouched,
                  setErrors,
                  errors,
                  handleSubmit,
                  values,
                  setFieldError,
                }) => {
                  const disableStatus =
                    censusErrors.length + payrollErrors.length > 0 ||
                    censusWarnings.length + payrollWarnings.length > 0
                      ? true
                      : false;
                  const handleClose = () => {
                    setModalOpen(false);
                  };
                  const returnArrowClick = () => {
                    setcountTrigger(!countTrigger);
                    setSliderOpen(false);
                    homeSetIsSubmit(true);
                    // history.push(
                    //   getAdvancedPathWithParam({
                    //     path: `${ROUTES.PAYROLL_FILE_STATUS}/${payrollId}?tab=2&amount=0`,
                    //     // pathParam: [FLOW_TYPES.ADD],
                    //   })
                    // );
                  };

                  const handleBack = () => {
                    //setToggleEmp(!toggleEmp);
                    // setErrorPage(false);
                    setIsSliderOpen(false);
                    setSliderOpen(false);
                    setDataChangeValidations([]);
                  };

                  if (dataChangeValidations.length == 0) {
                    return (
                      <ManagePayrollTabLayout
                        label={
                          selectedTabIndex == "warning"
                            ? "Warning Details"
                            : "Error Details"
                        }
                        className1="payroll-census-details"
                        // isLoading={isLoading1}
                        // returnArrow={true}
                        onReturnArrowClick={() => returnArrowClick()}
                        noStep={true}
                        isDeleteRecord={true}
                        onClick={() => onFormSubmit(values, { setErrors })}
                        isCensusPayrollPage={
                          isDeleteModalOpen || pendingSubmission ? false : true
                        }
                        isAllowedUpdate={isAllowedUpdate}
                        isAllowedDelete={isAllowedDelete}
                        onPayrollDeleteClick={onPayrollDeleteClick}
                        payrollId={payrollId}
                      >
                        <Form
                          autoComplete="off"
                          onSubmit={handleSubmit}
                          className="h-100 d-flex"
                        >
                          <div className="h-100 d-flex">
                            <div className="payroll-census-tabs">
                              <Tabs
                                defaultActiveKey="Census"
                                transition={false}
                                className="top-level-tab-var w-100"
                                onSelect={onCensusTabSelect}
                                activeKey={censusTabIndex}
                                // mountOnEnter
                                // unmountOnExit
                              >
                                {[
                                  UploadedFileType.IsDemographyOnly,
                                  UploadedFileType.IsBothDemographyAndPayrollOnly,
                                ].includes(fileTypeInformation) && (
                                  <Tab
                                    eventKey="census"
                                    title={
                                      <div className="d-flex onselect-highlight-error">
                                        <div className="mt-1">Census</div>{" "}
                                        <div
                                          className="circle-error-count"
                                          style={{
                                            background: "#919191",
                                          }}
                                        >
                                          {censusErrors?.length +
                                            censusWarnings?.length}
                                        </div>{" "}
                                      </div>
                                    }
                                  >
                                    <CensusFormDetails
                                      setIsLoading={setIsLoading}
                                      errorList={errorList}
                                      countries={countries}
                                      states={states}
                                      frequencyList={frequencyList}
                                      fileType={payrollDetails.fileType}
                                      setFieldError={setFieldError}
                                      setErrorList={setErrorList}
                                      setFieldTouched={setFieldTouched}
                                      fields={fields}
                                      data={census ? employeeData : null}
                                      awaitingFunding={
                                        pendingSubmission || !isAllowedUpdate
                                      }
                                      errorItemClick={(item) =>
                                        errorItemClick(item, "census")
                                      }
                                      isStartDate={isStartDate}
                                      isEndDate={isEndDate}
                                      setErrors={setErrors}
                                      censusWarnings={censusWarnings}
                                      setHoursErrorId={setHoursErrorId}
                                    />
                                  </Tab>
                                )}
                                {[
                                  UploadedFileType.IsPayrollOnly,
                                  UploadedFileType.IsBothDemographyAndPayrollOnly,
                                ].includes(fileTypeInformation) && (
                                  <Tab
                                    eventKey="payroll"
                                    title={
                                      <div className="d-flex onselect-highlight-error">
                                        <div className="mt-1">Payroll</div>{" "}
                                        <div
                                          className="circle-error-count"
                                          style={{
                                            background: "#919191",
                                          }}
                                        >
                                          {payrollErrors?.length +
                                            payrollWarnings?.length}
                                        </div>{" "}
                                      </div>
                                    }
                                  >
                                    <PayrollFormDetails
                                      setIsLoading={setIsLoading}
                                      fields={fields}
                                      data={values}
                                      pendingSubmission={
                                        pendingSubmission || !isAllowedUpdate
                                      }
                                      frequencyList={frequencyList}
                                      setErrorList={setErrorList}
                                      errors={employeeData?.errorMessages}
                                      setErrors={setErrors}
                                      errorList={errorList}
                                      warnings={get(
                                        employeeData,
                                        "warnings",
                                        []
                                      )}
                                      errorItemClick={(item) =>
                                        errorItemClick(item, "payroll")
                                      }
                                      setId={setDeleteContributionId}
                                      setError={setDeleteCompensationError}
                                      setHoursErrorId={setHoursErrorId}
                                    />
                                  </Tab>
                                )}
                              </Tabs>
                            </div>
                          </div>
                          <Modal show={isModalOpen} onHide={handleClose}>
                            <Modal.Body
                              style={{ borderTop: "5px solid #f94f50" }}
                            >
                              <div className="text-right">
                                <FontAwesomeIcon
                                  icon={faTimes}
                                  color="#000"
                                  onClick={handleClose}
                                />
                              </div>
                              <div className="d-flex">
                                <div className="pd-15">
                                  <FontAwesomeIcon
                                    icon={faExclamationTriangle}
                                    color="#f94f50"
                                    size="3x"
                                  />
                                </div>
                                <div className="remove-text">
                                  {notifications.map((x) => (
                                    <p>{x.messageDescCode} </p>
                                  ))}

                                  <br />
                                  <Button
                                    className="remove-btn mr-4"
                                    onClick={AcceptNotificationClick}
                                  >
                                    Ok
                                  </Button>
                                </div>
                              </div>
                            </Modal.Body>
                          </Modal>
                        </Form>
                      </ManagePayrollTabLayout>
                    );
                  } else {
                    return (
                      <SliderPanel
                        isOpen={isSliderOpen}
                        size="90"
                        showCancel={false}
                        showBackButton={false}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <p style={{ fontWeight: "500" }}>
                            Data Change Validation
                          </p>
                          <div style={{}}>
                            <Button
                              style={{ marginRight: "20px" }}
                              variant="secondary"
                              onClick={() => handleBack()}
                            >
                              Back
                            </Button>
                            {isAllowedUpdate ? (
                              <Button
                                variant="primary"
                                onClick={() => {
                                  onSubmitSave(values, {
                                    setErrors,
                                    setFieldError,
                                  });
                                }}
                              >
                                Submit
                              </Button>
                            ) : null}
                          </div>
                        </div>

                        <hr></hr>

                        <div style={{ display: "flex" }}>
                          <p style={{ fontSize: "12px", lineHeight: "18px" }}>
                            {ssnMasking(employeeInfo.uniqueId)}
                          </p>
                          <p
                            style={{
                              marginLeft: "30px",
                              fontSize: "12px",
                              lineHeight: "18px",
                            }}
                          >
                            {employeeInfo.employeeName}
                          </p>
                        </div>

                        <p
                          style={{
                            fontSize: "12px",
                            color: "#828282",
                            lineHeight: "25px",
                          }}
                        >
                          Following employee data changes were identified by the
                          system during validation process. Please select
                          appropriate data save option and click on 'Submit' to
                          continue
                        </p>
                        <div>
                          <Table className="datachangesvalidationtable">
                            <Table.Thead>
                              <Table.Tr>
                                {dataValidationTableHeader.map(
                                  (item, index) => {
                                    return (
                                      <Table.Th
                                        key={index}
                                        className={item.className}
                                        style={item.style}
                                      >
                                        {item.label}
                                      </Table.Th>
                                    );
                                  }
                                )}
                              </Table.Tr>
                            </Table.Thead>
                            <Table.Tbody>
                              <div
                                style={{
                                  maxHeight: "500px",
                                  wordWrap: "breakWord",
                                }}
                              >
                                {dataChangeValidations.map((data, index) => {
                                  fileValue = "";
                                  systemValue = "";
                                  if (
                                    data.controlName === "AddressDataChange" ||
                                    data.controlName === "EmployementStatus" ||
                                    data.controlName === "Classification"
                                  ) {
                                    fileValue = "";
                                    systemValue = "";
                                    let c = JSON.parse(data.dynamicValue1);
                                    let d = JSON.parse(data.dynamicValue2);

                                    if (
                                      data.controlName === "AddressDataChange"
                                    ) {
                                      if (!c.ForeignAddressIndicator) {
                                        delete c.ForeignCountry;
                                        delete c.ForeignState;
                                        delete d.ForeignCountry;
                                        delete d.ForeignState;
                                      } else {
                                        delete c.Country;
                                        delete c.State;
                                        delete d.State;
                                        delete d.Country;
                                      }
                                      delete c.ForeignAddressIndicator;
                                      delete d.ForeignAddressIndicator;
                                    }
                                    for (var i in c) {
                                      if (i === "ClassificationTypeId") {
                                        continue;
                                      }
                                      if (c[i] === null || c[i] === "")
                                        c[i] = " ";
                                      fileValue +=
                                        i + " : " + "\n" + c[i] + "\n";
                                    }

                                    //fileValue=data.dynamicValue1.split(',').map(str => <p>{str}</p>);
                                    for (var i in d) {
                                      if (i === "ClassificationTypeId") {
                                        continue;
                                      }
                                      if (d[i] === null || d[i] === "")
                                        d[i] = " ";
                                      systemValue +=
                                        i + " : " + "\n" + d[i] + "\n";
                                    }
                                  }
                                  return (
                                    <Table.Tr>
                                      <div
                                        style={{ display: "flex" }}
                                        className="datachangesvalidationtable"
                                      >
                                        <Table.Td
                                          style={
                                            dataValidationTableHeader[0].style
                                          }
                                        >
                                          <div className="temp1">
                                            {" "}
                                            {data.controlName}
                                          </div>
                                        </Table.Td>

                                        <Table.Td
                                          style={
                                            dataValidationTableHeader[1].style
                                          }
                                        >
                                          <div className="temp2">
                                            {" "}
                                            {data.messageCode}
                                          </div>
                                        </Table.Td>
                                        <Table.Td
                                          style={
                                            dataValidationTableHeader[2].style
                                          }
                                        >
                                          <div className="temp3">
                                            {fileValue === ""
                                              ? data.dynamicValue1 == ""
                                                ? "-"
                                                : data.dynamicValue1
                                              : fileValue}
                                          </div>
                                        </Table.Td>
                                        <Table.Td
                                          style={
                                            dataValidationTableHeader[3].style
                                          }
                                        >
                                          <div className="temp4">
                                            <div>
                                              {systemValue === ""
                                                ? data.dynamicValue2 == ""
                                                  ? "-"
                                                  : data.dynamicValue2
                                                : systemValue}
                                            </div>
                                          </div>
                                        </Table.Td>
                                        <Table.Td
                                          style={
                                            dataValidationTableHeader[4].style
                                          }
                                        >
                                          <div className="temp5">
                                            {" "}
                                            {data.controlName === "BirthDate" ||
                                            data.controlName ===
                                              "Classification" ||
                                            data.controlName ===
                                              "EmployementStatus" ||
                                            data.controlName === "HireDate" ||
                                            data.controlName ===
                                              "PayrollFrequency"
                                              ? "Accepting the file data may impact eligibility determination."
                                              : ""}
                                          </div>
                                        </Table.Td>
                                        <Table.Td
                                          style={
                                            dataValidationTableHeader[5].style
                                          }
                                        >
                                          <div className="temp6">
                                            <div
                                              style={{
                                                display: "flex",
                                                flexDirection: "column",
                                              }}
                                            >
                                              <div
                                                style={{
                                                  display: "flex",

                                                  flexDirection: "row",
                                                }}
                                              >
                                                <input
                                                  type="radio"
                                                  checked={
                                                    data.dataToSave == true
                                                  }
                                                  name={`dataToSave${index}`}
                                                  id={"File"}
                                                  value={true}
                                                  onClick={() => {
                                                    Func(true, index);
                                                  }}
                                                />
                                                <label
                                                  style={{
                                                    fontSize: "12px",
                                                    lineHeight: "18px",
                                                    marginLeft: "5px",
                                                    paddingTop: "10px",
                                                  }}
                                                  onClick={() => {
                                                    Func(true, index);
                                                  }}
                                                >
                                                  File
                                                </label>
                                              </div>
                                              <div
                                                style={{
                                                  display: "flex",
                                                  flexDirection: "row",
                                                }}
                                              >
                                                <input
                                                  type="radio"
                                                  checked={
                                                    data.dataToSave == false
                                                  }
                                                  name={`dataToSave${index}`}
                                                  id={"System"}
                                                  value={false}
                                                  onClick={() => {
                                                    Func(false, index);
                                                  }}
                                                />
                                                <label
                                                  style={{
                                                    fontSize: "12px",
                                                    lineHeight: "18px",
                                                    marginLeft: "5px",
                                                    paddingTop: "10px",
                                                  }}
                                                  onClick={() => {
                                                    Func(false, index);
                                                  }}
                                                >
                                                  System
                                                </label>
                                              </div>
                                            </div>
                                          </div>
                                        </Table.Td>
                                      </div>
                                    </Table.Tr>
                                  );
                                })}
                              </div>
                            </Table.Tbody>
                          </Table>
                        </div>
                      </SliderPanel>
                    );
                  }
                }}
              </Formik>
            </div>
          </div>
        </div>
      </LoaderWrapper>
    </div>
  );
};
export default PayrollCensusDetails;
